import React from 'react'

import { useFormContext } from 'react-hook-form'

import { LoadingBackdrop } from 'components/common'
import {
  CreateAndUpdateStrategicPartnerContactDtoInput,
  useGetStrategicPartnerContactQuery,
} from 'generated/graphql'

import ContactForm from './ContactForm'

interface IProps {
  contactId: number
}

const UpdateContact = (props: IProps) => {
  const { contactId } = props

  const { reset } = useFormContext<CreateAndUpdateStrategicPartnerContactDtoInput>()

  // Queries
  const { data, loading } = useGetStrategicPartnerContactQuery({
    variables: { strategicPartnerContactId: contactId },
  })

  React.useEffect(() => {
    if (data) {
      reset({ ...data.strategicPartnerContact })
    }
  }, [data, reset])

  return (
    <>
      <ContactForm />
      <LoadingBackdrop loading={loading} />
    </>
  )
}

export default UpdateContact
